import { Dices, Users, BookOpen, ShieldHalf, Swords } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  {
    icon: Dices,
    title: "Systém D&D 5E",
    desc: "Vlastnosti, dovednosti, záchranné hody, kouzla a boj podle pravidel D&D 5E.",
  },
  {
    icon: Users,
    title: "Živoucí svět",
    desc: "Živý svět utvářený hráči, událostmi a jejich rozhodnutími.",
  },
  {
    icon: BookOpen,
    title: "Forgotten Realms",
    desc: "Prozkoumej bohaté lore Faerûnu s vlastními lokacemi, frakcemi a příběhy.",
  },
  {
    icon: ShieldHalf,
    title: "Řízeno hráči",
    desc: "Cechy, politika, ekonomika a války – vše řídí komunita.",
  },
  {
    icon: Swords,
    title: "Epický RolePlay",
    desc: "Od hospodských pokeců po dlouhodobé kampaně. Na tvém příběhu záleží.",
  },
];

export const Features = () => {
  return (
    <section
      className="relative scroll-mt-20 px-6 pb-16 pt-[42px] lg:pb-20 lg:pt-[52px]"
      data-testid="features-section"
    >
      <div className="mx-auto max-w-[1584px] rounded-xl border border-white/10 bg-[#17171b] px-6 py-14 sm:px-10 lg:py-16">
        <Reveal className="mb-14 text-center">
          <p className="font-display text-xs font-600 uppercase tracking-[0.3em] text-[#F0801F]">
            Klíčové funkce
          </p>
          <h2 className="mt-3 font-display text-3xl font-600 uppercase tracking-tight text-white sm:text-4xl">
            Stvořeno pro RolePlay
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-5">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal
                key={f.title}
                delay={i * 0.08}
                className="group flex flex-col items-center text-center"
                data-testid={`feature-${i}`}
              >
                <span className="mb-5 grid h-16 w-16 place-items-center rounded-full border border-[#F0801F]/30 text-[#F0801F] transition-all duration-300 group-hover:border-[#F0801F] group-hover:bg-[#F0801F]/10">
                  <Icon className="h-7 w-7" strokeWidth={1.4} />
                </span>
                <h3 className="font-display text-sm font-600 uppercase tracking-[0.1em] text-white">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/50">
                  {f.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
